<template>
  <v-breadcrumbs
    v-if="breadcrumbs.length"
    :items="breadcrumbs"
  >
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :href="item.href"
        :to="item.to"
        :exact="item.exact"
        :disabled="item.disabled"
      >
        <v-icon
          v-if="item.icon"
          color="grey darken-2"
          class="mr-2"
        >
          {{ item.icon }}
        </v-icon>
        <span class="mention texte-gris-fonce">{{ item.text }} </span>
      </v-breadcrumbs-item>
    </template>
    <template v-slot:divider>
      <v-icon>
        mdi-chevron-right
      </v-icon>
    </template>
  </v-breadcrumbs>
</template>

<script>

export default {
  name: 'FilAriane',
  props: {
    isUtilisateurAgrial: {
      type: Boolean,
      default: false
    },
    isNonAgr: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breadcrumbs: []
    }
  },

  watch: {
    '$route' (newRoute) {
      this.updateBreadcrumbs(newRoute)
    }
  },
  mounted () {
    this.updateBreadcrumbs(this.$route)
  },
  methods: {
    updateBreadcrumbs (route) {
      this.breadcrumbs = []

      if (route.name !== 'main.tableau-de-bord' && route.name !== 'main') {
        // Parcours les parents défini dans les routes
        if (route.meta?.breadcrumb?.length > 0) {

          for (let i = 0; i < route.meta.breadcrumb.length; i++) {
            const parent = route.meta.breadcrumb[i]
              if (parent.icon) {
              this.breadcrumbs.push({
              text: parent.name,
              to: { name: parent.link },
              exact: true ,
              icon: parent.icon})
            }
            else {
              this.breadcrumbs.push({
              text: parent.name,
              to: { name: parent.link },
              exact: true})
            }
          }
        }

        this.breadcrumbs.push({
          text: route.meta.shortTitle || route.meta.title,
          to: route.path,
          exact: true })

      }

      if (this.breadcrumbs.length)
      {
        this.breadcrumbs[this.breadcrumbs.length - 1].disabled = true
      }

    }
  }
}
</script>
<style lang="scss">
.v-breadcrumbs {
  padding: 0 !important;
}

.v-breadcrumbs li:nth-child(even) {
  padding: 4px;
}
</style>
